export enum QueriesKey {
  AllUserMachin="AllUserMachin"
}
